import CardUserGroup from '../../../../layouts/Card/cardContent/CardUserGroup';

export const listSettings = {
    grid : {
        components : CardUserGroup,
        columns : {
            xs : 2,
            sm : 3,
            laptop : 3,
        }
    },
}

export const listMappers = [
    {
        view : 'card',
        mapper : null
    },
    // {
    //     view : 'table',
    //     mapper : 'companiesListMapper'
    // }
]

export const perPageOptions = {
    'card' : ['6'],
}